// extracted by mini-css-extract-plugin
export default {"myCoursesContainer":"styles_myCoursesContainer__VioK-"};